import * as z from 'zod';
import { dependentsSchema } from './dependentesSchema';
import { validaNomeCompleto } from '../../../../utils/ValidaNome';
import { validateCPF } from '../../../../utils/validations';

export const AssociadoSchema = z.object({
  id: z.number(),
  name: z.string().refine(val => validaNomeCompleto(val), {
    message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
  }),
  birthDate: z
    .string()
    .min(1, { message: 'Campo obrigatório' })
    .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, {
      message: 'Formato inválido (use DD/MM/AAAA)',
    })
    .refine(
      value => {
        const [dia, mes, ano] = value.split('/').map(Number);
        const date = new Date(ano, mes - 1, dia);

        // Verifica se o Date é válido e se os valores batem
        return (
          date.getFullYear() === ano &&
          date.getMonth() === mes - 1 &&
          date.getDate() === dia
        );
      },
      { message: 'Data de nascimento inválida' },
    ),
  cpf: z.string().refine(val => validateCPF(val.replace(/\D/g, '')), {
    message: 'CPF inválido',
  }),
  plano: z.number(),
  plano_vl: z.optional(z.string()),
  matricula: z.string(),
  departamentoId: z.number(),
  departamento: z.string(),
  dependentes: z.optional(z.array(dependentsSchema)),
});
